import React, { useState, useCallback } from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import UserPanel from '../user-panel/UserPanel';
import './Header.scss';
import { Template } from 'devextreme-react/core/template';
import type { HeaderProps } from '../../types';
import { Switch } from "devextreme-react/switch";
import { useTranslation } from 'react-i18next';

export default function Header({ menuToggleEnabled, title, toggleMenu }: HeaderProps) {
  const { i18n } = useTranslation(); 
  const [isSwitchedOn, setIsSwitchedOn] = useState(i18n.language === 'en');
  
  const onValueChanged = useCallback(
    (e: any) => {
      const language = e.value ? 'en' : 'it'; // Toggle between 'it' (Italian) and 'en' (English)
      i18n.changeLanguage(language); // Change language using i18next
      setIsSwitchedOn(e.value); // Update the switch state
    },
    [i18n]
  );

  const itLabelStyle = i18n.language === 'it' ? { color: 'red' } : {};
  const enLabelStyle = i18n.language === 'en' ? { color: 'red' } : {};
  
  return (
    <header className={'header-component'}>
      <Toolbar className={'header-toolbar'}>
        <Item
          visible={menuToggleEnabled}
          location={'before'}
          widget={'dxButton'}
          cssClass={'menu-button'}
        >
          <Button icon="menu" stylingMode="text" onClick={toggleMenu} />
        </Item>
        <Item
          location={'before'}
          cssClass={'header-title'}
          text={title}
          visible={!!title}
        />

        {/* Language Switch Section */}
        <Item location={'after'} cssClass="language-switch">
          <div className="language-switch-container">
            <span className="language-label" style={itLabelStyle}>IT</span> {/* Left label for IT */}
            <Switch
              value={isSwitchedOn} // Set the value based on the state (false = IT, true = EN)
              onValueChanged={onValueChanged}
            />
            <span className="language-label" style={enLabelStyle}>EN</span> {/* Right label for EN */}
          </div>
        </Item>
        <Item
          location={'after'}
          locateInMenu={'auto'}
          menuItemTemplate={'userPanelTemplate'}
        >
          <Button
            className={'user-button authorization'}
            width={210}
            height={'100%'}
            stylingMode={'text'}
          >
            <UserPanel menuMode={'context'} />
          </Button>
        </Item>
        <Template name={'userPanelTemplate'}>
          <UserPanel menuMode={'list'} />
        </Template>
      </Toolbar>
    </header>
)}
